<style lang="scss" scoped>
.sync {
  float: right;
  background: #17cfb8;
  border-color: #17cfb8;
  i {
    font-size: 20px;
    vertical-align: -2px;
    margin-right: 5px;
  }
}
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <tab :arr="arr"></tab>
      <el-button type="primary" class="sync" @click="asyncmaterial">
        <i class="iconfont icontongbubiaojiegou"></i>微信端素材同步
      </el-button>
    </div>
    <router-view ref="child"></router-view>
  </div>
</template>

<script>
import tab from '@/components/tab';
export default {
  props: ['id'],
  components: {
    tab,
  },
  computed: {},
  data() {
    return {
      type: this.$route.path
        .split('/')
        .slice(0, 5)
        .join('/'),
      arr: [
        {
          name: '关键词回复',
          url: `/third/${this.id}/autoReply/key`,
        },
        {
          name: '收到消息回复',
          url: `/third/${this.id}/autoReply/message`,
        },
        {
          name: '被关注回复',
          url: `/third/${this.id}/autoReply/focus`,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    async asyncmaterial() {
      let res = await this.$http.get(`/api/${this.id}/material/async`);
      if (res) {
        await this.$refs.child.getData();
        this.$message.success('同步成功');
      }
    },
  },
};
</script>
